/**
 * CollectionList Component
 * Displays all collections
 */

import { useCollections } from "../../hooks/useCollections";
import { CollectionCard } from "./CollectionCard";

export function CollectionList() {
  const { data: collections, isLoading, error } = useCollections();

  if (isLoading) {
    return (
      <div className="bg-surface-container-lowest rounded-lg shadow-3 p-12 text-center">
        <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-primary border-r-transparent"></div>
        <p className="mt-4 text-on-surface-variant">Collecties laden...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-error-container border border-error/30 text-on-error-container px-4 py-3 rounded-md">
        <p className="font-semibold">Fout bij laden van collecties</p>
        <p className="text-sm">{error.message}</p>
      </div>
    );
  }

  if (!collections || collections.length === 0) {
    return (
      <div className="bg-surface-container-lowest rounded-lg shadow-3 p-12 text-center">
        <div className="text-6xl mb-4">📂</div>
        <h3 className="text-xl font-semibold text-on-surface mb-2">Geen collecties gevonden</h3>
        <p className="text-on-surface-variant mb-6">
          Klik op "Nieuwe Collectie" om een collectie toe te voegen
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {collections.map((collection) => (
        <CollectionCard key={collection.collectionId} collection={collection} />
      ))}
    </div>
  );
}
